__turbopack_context__.v({
  "airportCode": "autocomplete-module-scss-module__Eryj2q__airportCode",
  "airportItem": "autocomplete-module-scss-module__Eryj2q__airportItem",
  "airportName": "autocomplete-module-scss-module__Eryj2q__airportName",
  "airportsList": "autocomplete-module-scss-module__Eryj2q__airportsList",
  "dropdown": "autocomplete-module-scss-module__Eryj2q__dropdown",
  "dropdownItem": "autocomplete-module-scss-module__Eryj2q__dropdownItem",
  "expandIcon": "autocomplete-module-scss-module__Eryj2q__expandIcon",
  "flag": "autocomplete-module-scss-module__Eryj2q__flag",
  "input": "autocomplete-module-scss-module__Eryj2q__input",
  "input-container": "autocomplete-module-scss-module__Eryj2q__input-container",
  "inputIcon": "autocomplete-module-scss-module__Eryj2q__inputIcon",
  "itemContent": "autocomplete-module-scss-module__Eryj2q__itemContent",
  "itemSubtitle": "autocomplete-module-scss-module__Eryj2q__itemSubtitle",
  "itemTitle": "autocomplete-module-scss-module__Eryj2q__itemTitle",
  "label": "autocomplete-module-scss-module__Eryj2q__label",
  "root": "autocomplete-module-scss-module__Eryj2q__root",
  "withIcon": "autocomplete-module-scss-module__Eryj2q__withIcon",
});
